export const PROVIDER_COLUMN_GAP = 16;
export const PROVIDER_COLUMN_MIN_WIDTH = 184; // 200 - PROVIDER_COLUMN_GAP
export const EVENT_CARD_GAP = 4;
export const EVENT_CARD_MIN_WIDTH = 68;
export const OVERLAPPING_EVENTS_BUTTON_WIDTH = 40;
export const OVERLAPPING_EVENTS_BUTTON_TOTAL_SPACE = OVERLAPPING_EVENTS_BUTTON_WIDTH + EVENT_CARD_GAP;
export const SCROLLABLE_BUTTON_WIDTH = 40;

// This is the width of the vertical hours lane where hours get displayed
export const HOURS_LANE_WIDTH = 76;
